import { render, staticRenderFns } from "./userCenter.vue?vue&type=template&id=22bd659d&scoped=true"
import script from "./userCenter.vue?vue&type=script&lang=js"
export * from "./userCenter.vue?vue&type=script&lang=js"
import style0 from "./userCenter.vue?vue&type=style&index=0&id=22bd659d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bd659d",
  null
  
)

export default component.exports